import { z } from 'zod';

/**
 * Configuración de la app (variables `VITE_*`, públicas: nunca secretos). Ver `.env.example`.
 * - `apiBaseUrl`: origen de la API sin `/v1` (vacío = mismo origen). Cambiarla apunta la app a la API real.
 * - `useMocks`: MSW con fixtures de `@paguz/contracts` (por defecto, si no hay URL base).
 * - `demoMode`: banner "Entorno de demostración" y ayuda con los OTP de demo.
 */
const flag = z
  .string()
  .optional()
  .transform((value) => (value === undefined || value === '' ? undefined : value === 'true'));

const EnvSchema = z.object({
  VITE_API_BASE_URL: z
    .string()
    .optional()
    .transform((value) => (value ?? '').trim().replace(/\/+$/, '')),
  VITE_API_MOCKS: flag,
  /** Alias con el mismo nombre que usa la consola (`VITE_USE_MOCKS=false` → API real). */
  VITE_USE_MOCKS: flag,
  VITE_DEMO_MODE: flag,
});

export interface AppConfig {
  readonly apiBaseUrl: string;
  readonly useMocks: boolean;
  readonly demoMode: boolean;
}

export function parseConfig(env: Record<string, unknown>): AppConfig {
  const parsed = EnvSchema.parse(env);
  return {
    apiBaseUrl: parsed.VITE_API_BASE_URL,
    useMocks: parsed.VITE_API_MOCKS ?? parsed.VITE_USE_MOCKS ?? parsed.VITE_API_BASE_URL === '',
    demoMode: parsed.VITE_DEMO_MODE ?? true,
  };
}

export const config: AppConfig = parseConfig(import.meta.env);
